import classNames from 'classnames/bind';
import React from 'react';
import { Checkbox as SemanticUiCheckbox } from 'semantic-ui-react';
import { CheckboxProps } from './Checkbox.types';
import styles from './Checkbox.module.scss';

const cx = classNames.bind(styles);

const Checkbox = ({ dataTestId, className, ...rest }: CheckboxProps): React.ReactElement => (
  <SemanticUiCheckbox className={cx('body', className)} data-testid={dataTestId} {...rest} />
);

export default Checkbox;
